import { Component } from '@angular/core';

@Component({
  selector: 'app-select-version-comparison',
  templateUrl: './select-version-comparison.component.html',
  styleUrls: ['./select-version-comparison.component.scss'],
})
export class SelectVersionComparisonComponent {}
